import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import ptTranslation from './locales/pt/translation.json';
import itTranslation from './locales/it/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
  it: {
    translation: itTranslation,
  },
};

// Custom language detector - only supports pt, es, it from browser; defaults to en
const customDetector = {
  name: 'customBrowserDetector',
  lookup() {
    // Check if user has manually set a language (stored in localStorage)
    const stored = localStorage.getItem('i18nextLng');
    if (stored && ['en', 'es', 'pt', 'it'].includes(stored)) {
      return stored;
    }

    // Detect from browser language
    const browserLang = navigator.language.split('-')[0]; // 'pt-BR' → 'pt'
    const supportedLangs = ['pt', 'es', 'it'];
    
    // If browser language is one we support, use it; otherwise default to English
    return supportedLangs.includes(browserLang) ? browserLang : 'en';
  },
  cacheUserLanguage(lng) {
    localStorage.setItem('i18nextLng', lng);
  }
};

// Add custom detector
const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetector);

i18n
  // Detect user language
  .use(languageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en', // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['customBrowserDetector'],
      caches: ['localStorage']
    },
  });

export default i18n;
